/**
 * Symbolic name of the action for logging in.
 */
export const LOGIN = 'LOGIN';
